import { render, staticRenderFns } from "./OrderPrecierreTab.vue?vue&type=template&id=323d3fa2&"
import script from "./OrderPrecierreTab.vue?vue&type=script&lang=js&"
export * from "./OrderPrecierreTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrecierreTab.vue?vue&type=style&index=0&id=323d3fa2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports